import { STATIC_CONFIG_URL } from "@/configs/static-config"

export type StaticConfigMaintenanceTarget = "web" | "all" | string

export interface StaticConfig {
  platforms?: {
    web?: Record<string, unknown>
    all?: Record<string, unknown>
    [key: string]: Record<string, unknown> | undefined
  }
  maintenance?: StaticConfigMaintenanceTarget[]
}

export async function getStaticConfig(): Promise<StaticConfig> {
  if (!STATIC_CONFIG_URL) {
    throw new Error("VITE_STATIC_CONFIG_BASE_URL is not defined")
  }

  const response = await fetch(STATIC_CONFIG_URL, {
    cache: "no-cache",
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch static config: ${response.status}`)
  }

  return response.json()
}
